<template>
  <div class="all">
    <div class="content" ref="printMe" v-if="!output">
      <div class="title">
        <logo :logo="aiyouth" :inputStyle="logoStyle"></logo>
        <my_button :value="'等你来战'" :inputStyle="buttonStyle"></my_button>
      </div>
      <div class="body">
        <div class="user">
          <div class="avatar">
            <my_image :src="avatar" :width="'192px'"></my_image>
          </div>
          <div class="text">{{userInfo}}</div>
        </div>
        <div class="rank"> <div class="board"> <my_image :src="rankPng" :width="'1.2em'"></my_image>
            <div>我的排名（{{date}} 20:00更新）</div>
          </div>

          <div class="area">{{area}}</div>
          <div class="ranknop">第 <b>{{rank.prov}}</b> 名</div>

          <div class="area">全国排行</div>
          <div class="ranknon">第 <b>{{rank.national}}</b> 名</div>

        </div>
        <div class="split"></div>
        <div class="qr">
          <div class="text">
            长按保存海报分享或识别二维码
            <br>
            关注公众号了解更多大赛信息
            <br>
            初赛截止时间:11月11日23: 59
          </div>
          <my_image :src="imgcoco" :width="'112px'"></my_image>
          <my_image :src="imgfinger" :width="'112px'"></my_image>
        </div>
        <div class="desc">
          AI算法挑战活动简介:
          <br>
          AI算法挑战活动是赛迪人工智能大赛的简称，青少年编程挑战活动面向
          对编程感兴趣的中小学生，零基础零门槛零报名费，以赛促学，
          接触编程了解编程，然后逬行编程竞技。大赛甶工信部赛迪研究
          院培训中心主管和运营，由CodeCombat提供技术平台支持。
        </div>
      </div>
    </div>
    <div class="mb" v-if="output">
      <div>生成分享海报中，请稍候...</div>
    </div>
    <div>
      <img :src="output" class="img">
    </div>
  </div>
</template>

<script>
  import Logo from '@/components/Logo.vue'
  import MyButton from '@/components/Button.vue'
  import MyImage from '@/components/Image.vue'
  import rankPng from '@/assets/image/share/rank.png'
  import qrPng from '@/assets/image/share/qr.png'
  import fingerPng from '@/assets/image/share/finger.png'

  export default {
    name: 'Share',
    computed: {
      rankPng() {
        return rankPng
      },
      imgcoco() {
        /* return 'https://coco-assets.oss-cn-beijing.aliyuncs.com/aiyouth/images/bottombar/coco-qr.png'*/
        return qrPng
      },
      imgfinger() {
        return fingerPng
      },
      avatar() {
        let index = (this.id % 16) | 0
        return require('@/assets/image/avatar/' + index + '.png')
      },
      userInfo() {
        return '我是' + this.username + '\n' + '我在AI算法挑战活动' + this.group + '\n你敢来挑战吗?'
      },
      aiyouth() {
        return this.$store.state.logo.mainBlack
      },
      logoStyle() {
        return {
          'height': '60px'
        }
      },
      buttonStyle() {
        return {
          'border-radius': '5vw',
          'font-size': '28px',
          'display': 'flex',
          'align-items': 'center',
          'justify-content': 'center',
          'width': '5.5em',
          'height': '60px'
        }
      }
    },
    data() {
      return {
        rank: {prov: '尚无排名', national: '尚无排名'},
        area: '',
        id: 0,
        group: '',
        username: '',
        output: false
      }
    },
    methods: {
      async print() {
        const el = this.$refs.printMe
        const options = {
          type: 'dataURL'
        }
        this.output = await this.$html2canvas(el, options)
      }
    },
    mounted() {
      this.$store.commit('SET_MEDIAPHONE', true)
      this.$http.get('/api/rank/share/' + this.$route.params.uuid)
        .then(res => {
          console.log(res)
          this.area = res.data.province_name
          this.rank.prov = res.data.province_rank == -1 ? '尚无排名' : res.data.province_rank
          this.rank.national = res.data.national_rank == -1 ? '尚无排名' : res.data.national_rank
          this.id = res.data.id
          this.username = res.data.username
          this.group = res.data.group
          this.date = res.data.date
          document.title = this.username + '的AI算法挑战活动战绩|' + res.data.date
          this.print()
        })
    },
    components: {
      logo: Logo,
      my_button: MyButton,
      my_image: MyImage
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .all{
    font-size: 30px;
  }

  .title, .body{
    background: white;
    display: flex;
    box-sizing: border-box;
  }

  .title{
    border-radius: 1vw;
    width: 86%;
    height: 5%;
    padding-left: 5%;
    padding-right: 5%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5%;
  }

  .body{
    box-shadow: 0px 0px 16px 0px rgba(0, 0,,, 0.39);
    /* width: 86%;
       height: 80%; */
    padding-left: 8%;
    padding-right: 8%;
    flex-direction: column;
    justify-content: space-around;
  }

  .content{
    /* background: url('https://coco-assets.oss-cn-beijing.aliyuncs.com/aiyouth/images/share/%E6%91%84%E5%9B%BE%E7%BD%91_400653681.png'); */
    background: url('~@/assets/image/share/bg.png');
    background-size: auto 100%;
    background-position: center;
    width: 980px;
    height: 1800px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .user .text{
    white-space: pre;
    line-height: 84px;
  }

  .body .user{
    display: flex;
    align-items: center;
  }

  .user .avatar{
    margin-right: 10%;
    margin-top: 42px;
  }

  .qr{
    display: flex;
    color: #999999;
    align-items: center;
    justify-content: space-between;
  }

  .qr .text{
    width: 56%;
    font-size: 27px;
  }

  .split{
    height: 2px;
    background: #eeeeee;
  }

  .desc{
    color: #666666;
    font-size: 24px;
  }

  .area{
    display: flex;
    align-items: center;
    font-size: 38px;
    margin-top: 20px;
  }

  .mb{
    width: 100vw;
    height: 100vh;
    background-color: rgba(10, 10, 10, 0.8);
    position: fixed;
    top: 0;
    display: flex;
    /* align-items:center; */
    justify-content: center;
    left: 0;
  }

  .mb > div{
    position: absolute;
    top: 5em;
    font-size: 6vw;
    color: white;
  }

  .img{
    width: 100vw;
  }

  .board{
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .board > div{
    margin-left: 10px;
  }

  .rank{
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .ranknop{
    font-size: 60px;
  }

  .ranknop b{
    font-size: 120px;
  }

  .ranknon{
    font-size: 50px;
  }

  .ranknon b{
    font-size: 100px;
  }

  .rank .area{
    font-size: xx-large;
    margin-top: 40px;
  }
</style>
